var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38014",
    "data-name": "Group 38014",
    transform: "translate(372 -1285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14637",
    "data-name": "Rectangle 14637",
    width: 32,
    height: 32,
    transform: "translate(-372 1285)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "validating-ticket",
    d: "M28.169,14H29a1,1,0,0,0,1-1V10a3,3,0,0,0-3-3H5a3,3,0,0,0-3,3v3a1,1,0,0,0,1,1h.831A2.13,2.13,0,0,1,6,15.852a2.008,2.008,0,0,1-.582,1.562A1.988,1.988,0,0,1,4,18H3a1,1,0,0,0-1,1v3a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V19a1,1,0,0,0-1-1H28a2,2,0,0,1-2-2.148A2.13,2.13,0,0,1,28.169,14Zm-3,4.827A3.973,3.973,0,0,0,28,20v2a1,1,0,0,1-1,1H21V21a1,1,0,0,0-2,0v2H5a1,1,0,0,1-1-1V20a4,4,0,0,0,3.989-4.291A4.1,4.1,0,0,0,4,12V10A1,1,0,0,1,5,9H19v2a1,1,0,0,0,2,0V9h6a1,1,0,0,1,1,1v2a4.1,4.1,0,0,0-3.989,3.706A4.005,4.005,0,0,0,25.173,18.827ZM21,15v2a1,1,0,0,1-2,0V15a1,1,0,0,1,2,0Z",
    transform: "translate(-371.993 1285)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.ab897d6b0fc951f5bd38ede0b8bd29c4.svg";
export { ForwardRef as ReactComponent };